import { type api } from "@skilitics/publish-endpoint-definitions";

import { distributionPublishApiClient as apiClient } from "./useDistributionPublishApiClient.ts";

type Api = typeof api;

// this BS is because of axios types leaking through zodios. copilot wrote this code
export interface DistributionPublishApi {
  publish: (payload: Parameters<Api["addPublishedModule"]>[0]) => ReturnType<Api["addPublishedModule"]>;
  getPlayerVersions: () => ReturnType<Api["getPlayerVersions"]>;
  getPublishedModules: (moduleId: string) => ReturnType<Api["getPublishedModulesByModuleId"]>;
  getPublishedModuleLatestVersions: (tags?: string[], all?: boolean) => ReturnType<Api["getPublishedModulesLatest"]>;
  addDistributionUnit: (payload: Parameters<Api["addDistributionUnit"]>[0]) => ReturnType<Api["addDistributionUnit"]>;
  getLatestDistributionUnits: () => ReturnType<Api["getLatestDistributionUnits"]>;
  getDistributionUnitsForModuleSet: (moduleSetId: string) => ReturnType<Api["getDistributionUnitsForModuleSet"]>;
  getDistributionGroups: () => ReturnType<Api["getDistributionGroups"]>;
}

const distributionPublishApi: DistributionPublishApi = {
  publish: (payload) => apiClient.addPublishedModule(payload),
  getPlayerVersions: () => apiClient.getPlayerVersions(),
  getPublishedModules: (moduleId) => apiClient.getPublishedModulesByModuleId({ params: { moduleId } }),
  getPublishedModuleLatestVersions: (tags, all) => apiClient.getPublishedModulesLatest({ queries: { tags, all } }),
  addDistributionUnit: (payload: Parameters<typeof apiClient.addDistributionUnit>[0]) =>
    apiClient.addDistributionUnit(payload),
  getLatestDistributionUnits: () => apiClient.getLatestDistributionUnits(),
  getDistributionUnitsForModuleSet: (moduleSetId) =>
    apiClient.getDistributionUnitsForModuleSet({ params: { moduleSetId } }),
  getDistributionGroups: () => apiClient.getDistributionGroups(),
};

export const useDistributionPublishApi = () => distributionPublishApi;
